import { NavLink } from "react-router-dom";
import { ReactNode } from "react";

type NavItemProps = {
  listClass?: string;
  to: string;
  label: string;
  icon: ReactNode;
  onLinkClick?: () => void;
  end?: boolean;
};

function NavItem({
  listClass = "px-3",
  to,
  label,
  icon,
  onLinkClick,
  end,
}: NavItemProps) {
  return (
    <li className={listClass}>
      <NavLink
        to={to}
        className="nav-link"
        aria-current="page"
        onClick={onLinkClick}
        end={end}
      >
        <div className="sidebar-link">
          <span>{label}</span>
          {icon}
        </div>
      </NavLink>
    </li>
  );
}

export default NavItem;
